// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pH51","content":"styles_content__1F8xI","tableWrap":"styles_tableWrap__3oTeP"};